import React from 'react';
import Icon from './Icon';
import { industries } from '../mock/mock';

export default function IndustriesGrid() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {industries.map((v) => (
        <div key={v.name} className="reveal group rounded-2xl p-6 border border-slate-200 bg-slate-50 hover:bg-slate-100 hover:border-[#2563eb]/40 transition-colors">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#2563eb]/18 to-[#4f46e5]/18 grid place-items-center text-[#2563eb] mb-4 group-hover:scale-110 transition-transform">
            <Icon name={v.icon} size={22} />
          </div>
          <h3 className="font-display text-lg font-semibold text-slate-900 mb-1.5">{v.name}</h3>
          <p className="text-sm text-slate-500 leading-relaxed">{v.desc}</p>
        </div>
      ))}
    </div>
  );
}
